import styled from 'styled-components/native';

export default styled.View`
  padding: 16px;
  background: ${({ theme }) => theme.card.background};
  border-radius: 14px;
  margin-top: 20px;
`;
